<div class="grid grid-nogutter mb-3">
  <div class="col-12 md:col-6 sm:col-12 sm:mb-2">
    <h1 class="h4 m-0">{{'Search Markets' | sentenceCase}}</h1>
  </div>
  <div
    class="col-12 md:col-6 sm:col-12 flex md:justify-content-end justify-content-between mt-3 md:mt-0 align-items-start sm:align-items-center md:gap-4 gap-0"
  >
  @if(showEditCreate){
    <p-button
      label="create"
      [rounded]="true"
      icon="pi pi-plus"
      size="large"
      (onClick)="showCreateSearchMarketModal($event)"
    />
  }
  </div>
</div>
<div class="projects-data">
  <div class="grid grid-nogutter">
    <div class="col-12 p-0">
      <p-table
        styleClass="p-datatable-sm p-datatable-sm--normal"
        [value]="searchMarkets"
        [paginator]="true"
        [rows]="10"
        [tableStyle]="{ 'min-width': '50rem' }"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} - {last} of {totalRecords}"
        autoLayout="true"
        [scrollable]="true"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>S.No</th>
            <th>
              Name
            </th>
            <th>
              Status
            </th>
            @if(showEditCreate){
              @if (helperService.checkResponsive()) {
                <th style="width: 15%;" alignFrozen="right" pFrozenColumn>
                  <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                </th>
                } @else {
                <th style="width: 8%">
                  <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                </th>
              }
              <ng-template #frozenHeader>
              Actions
              </ng-template>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-searchMarket let-rowIndex="rowIndex">
          <tr>
            <td>{{ rowIndex + 1 }}</td>
            <td>{{ searchMarket.name }}</td>
            <td>
              @if(searchMarket.isActive){
                <p-tag value="Active" [rounded]="true" class="pillActive" />
              }
              @else {
                <p-tag value="Inactive" [rounded]="true" class="pillInactive" />
              }
            </td>
            @if(showEditCreate){
              @if (helperService.checkResponsive()) {
                <td alignFrozen="right" pFrozenColumn>
                  <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                </td>
                } @else {
                <td>
                  <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                </td>
                } 
               <ng-template #frozenData>
                <div class="wrap-actions flex align-items-center gap-2">
                  <p-button
                    pTooltip="Edit" 
                    tooltipPosition="top"
                    [rounded]="true"
                    [text]="true"
                    icon="true"
                    (click)="showEditSearchMarketModal($event, searchMarket)"
                  >
                    <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                  </p-button>
                  <p-button
                    [pTooltip]="searchMarket.isActive? 'Deactivate': 'Activate'"
                    tooltipPosition="top"
                    (click)="onArchive($event, searchMarket)"
                    [rounded]="true"
                    [text]="true"
                    icon="true"
                  >
                    <span class="{{helperService.getEnvironmentName()}}-icon icon-archive-outlined"></span>
                  </p-button>
                  <p-button
                  pTooltip="Delete" 
                  tooltipPosition="top"
                  [rounded]="true"
                  [text]="true"
                  icon="true"
                  (click)="onDelete($event, searchMarket)"
                >
                  <span class="{{helperService.getEnvironmentName()}}-icon icon-delete-outlined red"></span>
                </p-button>
                </div>
              </ng-template>
            }
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
